import "./WhoWeServe.css";

// Libraries
import { NavLink } from "react-router-dom";

import imgResellers from "../../assets/resellers.jpg";
import imgAffiliates from "../../assets/affiliates.jpg";
import imgTravel from "../../assets/travel.jpg";
import imgMVNO from "../../assets/mvno.jpg";
import imgMNO from "../../assets/mno.jpg";
import imgFintech from "../../assets/fintech.jpg";
import imgEnterprise from "../../assets/enterprise.jpg";
import imgHospitality from "../../assets/hospitality.jpg";
import imgBooking from "../../assets/booking.jpg";
import imgAir from "../../assets/air.jpg";
import imgIoT from "../../assets/iot.jpg";
import { Helmet } from "react-helmet";

const data = [
  {
    key: "resellers",
    title: "eSIM resellers",
    lead: "Become a Globtel Partner – Sell SIM and eSIM Cards Under Your Own Brand",
    bullets: [
      "Global coverage – SIM and eSIM working in 190+ countries.",
      "White label – customizable web platform and mobile apps for Android and iOS.",
      "API integration – full control over digital channels and high‑quality eSIM delivery.",
      "New revenue stream – earn on every sale and every top‑up.",
      "Instant customer acquisition – ready‑to‑use tools from day one.",
      "Flexible business models – prepaid, postpaid, regional bundles, subscriptions.",
      "Fast onboarding – easy integration, comprehensive support, partner‑first approach.",
      "Join the Globtel partner network and expand with future‑proof connectivity.",
    ],
  },
  {
    key: "affiliates",
    title: "eSIM affiliates",
    lead: "Earn with eSIM – Join the Globtel Affiliate Program",
    bullets: [
      "Passive income on every eSIM sale and every top‑up.",
      "Global product – coverage in 190+ countries.",
      "High demand – travellers need internet in every destination.",
      "20% commission on every transaction – initial purchase and repeat top‑ups.",
      "Ready‑to‑use tools – affiliate links, banners, widgets.",
      "No barriers – simple sign‑up, instant approval, no commitment.",
    ],
  },
  {
    key: "travel",
    title: "Travel Industry",
    lead: "Why choose the Globtel eSIM platform?",
    bullets: [
      "Global coverage – internet in 190+ countries.",
      "Easy to use – activate in seconds, no plastic cards or local queues.",
      "White label – app, client portal, and sales materials under your brand.",
      "New revenue – earn from activations and data packages.",
      "Stronger offer – connectivity included in the travel experience.",
    ],
  },
  {
    key: "mvno",
    title: "MVNO",
    lead: "Turn roaming pressure into opportunity with Globtel’s eSIM platform.",
    bullets: [
      "Global coverage at competitive rates – reduce roaming burden.",
      "White‑label web platform and apps under your brand.",
      "API‑first integration – keep full control of digital channels.",
      "Fair economics – competitive wholesale, no hidden markups or multi‑IMSI lock‑in.",
      "Rapid go‑to‑market – launch in weeks, monetize travel immediately.",
      "Loyalty & new revenue – keep subscribers instead of losing them to travel eSIM vendors.",
    ],
  },
  {
    key: "mno",
    title: "MNO",
    lead: "Defend loyalty and revenues with fair roaming bundles.",
    bullets: [
      "Global eSIM reach – 190+ destinations with 25+ direct carrier agreements.",
      "Competitive roaming at market rates – retain outbound revenue.",
      "Safeguard inbound revenues while staying attractive on outbound.",
      "White‑label eSIM platform and apps under your brand.",
      "API integration – fast, simple connection to existing systems.",
      "New wholesale income – monetize unused capacity globally.",
      "Enterprise‑grade – 99.99% uptime, Tier 3 DCs, GDPR compliance.",
    ],
  },
  {
    key: "fintech",
    title: "Fintech",
    lead: "Add Connectivity to Your Financial Services",
    bullets: [
      "Embedded connectivity – integrate eSIM alongside wallets and payments.",
      "Global reach – affordable internet in 190+ countries.",
      "White‑label solutions fully aligned to your brand.",
      "New revenue – earn from eSIM sales and top‑ups.",
      "Frictionless onboarding – instant activation and simple APIs.",
      "Customer loyalty – make your app the connected daily hub.",
    ],
  },
  {
    key: "enterprise",
    title: "Enterprise",
    lead: "Global Connectivity Made Simple",
    bullets: [
      "Worldwide coverage – reliable access in 190+ countries.",
      "Flexible plans – pay‑as‑you‑go, unlimited, subscriptions.",
      "White‑label web and mobile apps for employees or customers.",
      "Business efficiency – one platform for procurement and management.",
      "API integration – connect with IT/HR/travel systems.",
      "Security – GDPR, encryption, 99.99% uptime.",
      "Cost control – predictable pricing and optimized roaming.",
    ],
  },
  {
    key: "hospitality",
    title: "Hospitality & Hotels",
    lead: "Enhance Guest Experience with Seamless Connectivity",
    bullets: [
      "Instant global internet for international guests.",
      "No SIM hassle – QR or app activation in seconds.",
      "White‑label apps and portals under your property brand.",
      "New revenue – commission on sales and top‑ups.",
      "Stronger loyalty – position your property as a travel partner.",
      "Upsell – bundle eSIM with bookings or VIP packages.",
    ],
  },
  {
    key: "booking",
    title: "Booking Platforms",
    lead: "Add Value Beyond the Reservation",
    bullets: [
      "Global coverage – 190+ countries.",
      "Instant activation – no physical SIM.",
      "White‑label integration in the booking journey.",
      "Additional revenue – commission on sales and top‑ups.",
      "Upsell – bundle with flights, hotels, packages.",
      "Customer loyalty – one‑stop experience from booking to connectivity.",
    ],
  },
  {
    key: "air",
    title: "Airlines & Airports",
    lead: "Keep Travellers Connected",
    bullets: [
      "Global coverage – affordable mobile internet in 190+ destinations.",
      "Instant activation – QR or app; no kiosks, no local SIM hunt.",
      "White‑label solution embedded into apps and loyalty.",
      "New revenue streams beyond traditional ancillary.",
      "Upsell – bundle with tickets, lounges, duty‑free.",
      "Enhanced passenger experience end‑to‑end.",
    ],
  },
  {
    key: "iot",
    title: "IoT & Embedded Devices",
    lead: "Reliable Connectivity for Smart Innovation",
    bullets: [
      "One eSIM profile for 190+ countries, no multi‑SIM complexity.",
      "Always‑on performance with intelligent network selection.",
      "Enterprise‑grade security – encrypted, GDPR, 99.99% uptime.",
      "Seamless integration – APIs and provisioning toolchain.",
      "Flexible models – PAYG, subscription, tailored at scale.",
      "Scalability – manage thousands or millions from one platform.",
    ],
  },
];

const images = {
  resellers: imgResellers,
  affiliates: imgAffiliates,
  travel: imgTravel,
  mvno: imgMVNO,
  mno: imgMNO,
  fintech: imgFintech,
  enterprise: imgEnterprise,
  hospitality: imgHospitality,
  booking: imgBooking,
  air: imgAir,
  iot: imgIoT,
};

const WhoWeServe = () => {
  return (
    <section className="serve">
      <Helmet>
        <title>GlobTel Esim - Who We Serve</title>
      </Helmet>
      <header className="serve__hero">
        <h1>Who We Serve</h1>
        <p className="serve__lead">
          From resellers and affiliates to enterprises and carriers, Globtel’s
          white‑label eSIM platform powers modern, global connectivity.
        </p>
        <div className="serve__cta">
          <NavLink to="/become-a-partner" className="btn btn--primary">
            Become a Partner
          </NavLink>
          {/* <a href="#docs" className="btn btn--outline">
            View API Docs
          </a> */}
        </div>
      </header>

      <div className="serve-rows">
        {data.map((s, idx) => (
          <section
            key={s.key}
            className={`serve-row ${idx % 2 ? "is-reversed" : ""}`}
          >
            <div className="serve-row__inner">
              <div className="serve-row__text">
                <h3 className="serve-row__title">{s.title}</h3>
                <p className="serve-row__lead">{s.lead}</p>
                <ul className="serve-row__list">
                  {s.bullets.map((b, i) => (
                    <li key={i}>{b}</li>
                  ))}
                </ul>
              </div>
              <div className="serve-row__media">
                <img src={images[s.key]} alt="" loading="lazy" />
              </div>
            </div>
          </section>
        ))}
      </div>
    </section>
  );
};

export default WhoWeServe;
